import { makeObservable, observable } from 'mobx';
import { v4 } from 'uuid';

import type { TRawRigOperationSection, TRawRigOperationStage, TTheWell } from '../types';

export type TTheWellData = TTheWell & {
  passingByMonth: Record<number, Record<number | 'total', number>>;
  stagesByStageType: Record<number, TRawRigOperationStage>;
  sectionsBySectionType: Record<number, TRawRigOperationSection>;
  csByYears: Record<number, number>;
};

export class TheWellEntity {
  readonly entityId = v4();

  @observable.ref data: TTheWellData;

  constructor(data: TTheWellData) {
    this.data = data;

    makeObservable(this);
  }
}
